import React, { useState, useEffect } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import { Dimmer } from "../components/spinner";
import axios from "axios";
import { ModalDeclararMinas } from "../components/minas/modalDeclararMinas";
import { Mensaje } from "../components/mensajes";
import useTable from "../components/useTable";
import { formatMoneda } from "../util/varios";

const DeclaracionMina = () => {
  const op = require("../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const anioActu = JSON.parse(localStorage.getItem("anioactu"));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));

  const headCells = [
    {
      id: "codigo",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-code">
          {" "}
          CODIGO
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "nombre",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-signature">
          {" "}
          NOMBRE
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "rif",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-id-card">
          {" "}
          RIF
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "nrolicencia",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-id-card">
          {" "}
          NRO. LICENCIA
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "estatus",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-check-square">
          {" "}
          ESTATUS{" "}
        </i>
      ),
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: (
        <i style={{ textAlign: "center" }} className="fas fa-users-cog">
          {" "}
          OPCIONES
        </i>
      ),
      textAlign: "center",
    },
  ];

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mostrar5, setMostrar5] = useState(false);
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(1);
  const [indice, setIndice] = useState(-1);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [agente, setAgente] = useState();
  const [persona, setPersona] = useState();
  const [configMinas, setConfigMinas] = useState();
  const [claseMinaxAgen, setClaseMinaxAgen] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [totDeuda, setTotDeuda] = useState("0,00");
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    let st = "";
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            st = x.statusmina === "51" ? "activo" : "inactivo";
            if (
              x.idagente.includes(target.value) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.rif.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nrolicenciamina
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              st.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };
  useEffect(() => {
    consultar_minas();
    seleccionarConfiguracion();
    setActivate(true);
  }, []);

  const consultar_minas = () => {
    setActivate(true);

    let campos = "*";
    let nomtab = "agente";
    let nomid = "idtipoagente";
    let nomid2 = "mina";
    let orden = "idagente";

    let endpoint = `${
      op.conexion
    }/api/consulta/idsstring2rows?&campos=${campos}&id=${5}&nomid=${nomid}&nomtab=${nomtab}&nomid2=${nomid2}&id2=${true}&orden=${orden}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarConfiguracion = () => {
    let nanio = parseInt(fechaSistema.substring(1, 5));
    let endpoint = `${op.conexion}/api/minas/configuracionminas?nanio=${nanio}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setConfigMinas(response.data);
          if (response.data.valorutMulta === null) {
            if (response.data.factormulta === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Información",
                texto:
                  "El valor de la unidad tributaria para el año " +
                  anioActu +
                  " no esta definido",
                icono: "informacion",
              });
            } else if (response.data.factormulta > 2) {
              let tipo = response.data.factormulta - 3;
              setMensaje({
                mostrar: true,
                titulo: "Información",
                texto:
                  "El valor del " +
                  (tipo === 0
                    ? "Petro"
                    : tipo === 1
                    ? "Sueldo Minimo"
                    : tipo === 2
                    ? "UCAMP"
                    : "") +
                  " para el año " +
                  anioActu +
                  " en el mes en curso no esta definido",
                icono: "informacion",
              });
            }
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        //setActivate(false);
      });
  };

  const realizarDeclaracion = (item) => (event) => {
    event.preventDefault();
    setDeshabilitado(false);
    setOperacion(1);
    setActivate(true);
    SelectAgente(item.idagente);
  };

  const SelectAgente = (idagente) => {
    let endpoint = `${op.conexion}/api/agente/veragente/${idagente}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idagente > 0) {
            setAgente(response.data);
            setPersona({
              cedula: response.data.cedula,
              nombres: response.data.nombres,
              apellidos: response.data.apellidos,
              correoe: response.data.correoe,
              tlf1: response.data.tlf1,
              tlf2: response.data.tlf2,
              fnacimiento: response.data.fnacimiento,
              nacionalidad: response.data.nacionalidad,
              sexo: response.data.sexo,
              direccion: response.data.direccionp,
            });
            SelectClaseMinasAgente(response.data.idagente);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "error al cargar el comercio",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        //setActivate(false);
      });
  };

  const SelectClaseMinasAgente = (idagente) => {
    let endpoint = `${op.conexion}/api/minas/claseminasxagente/${idagente}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.length > 0) {
            var cxa = [];
            for (let i = 0; i < response.data.length; i++) {
              cxa.push({
                alicuota: response.data[i].alicuota,
                codigoclaseminas: response.data[i].codigoclaseminas,
                descripcion: response.data[i].descripcion,
                idclaseminas: response.data[i].idclaseminas,
                minimo: response.data[i].minimo,
                metrocubico: "0,00",
                montobruto: "0,00",
                montounidad: "0,00",
                montoapagar: "0,00",
              });
            }

            setClaseMinaxAgen(cxa);
          } else {
            setClaseMinaxAgen([]);
          }
          SelectDeudaAgenMina(idagente);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        //setActivate(false);
      });
  };

  const SelectDeudaAgenMina = (idagente) => {
    let endpoint = `${
      op.conexion
    }/api/minas/deudas?idagente=${idagente}&fecha=${fechaSistema}&tabconf=${"configminas"}&condic=${"tipodeuda=1"}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          var totdeu = parseFloat(0.0);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              totdeu =
                totdeu +
                parseFloat(response.data[i].mondeu) +
                parseFloat(response.data[i].intmoradeu) +
                parseFloat(response.data[i].recargodeu) +
                parseFloat(response.data[i].multa);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            }
          }
          setTotDeuda(
            formatMoneda(totdeu.toString().replace(".", ","), ",", ".", 2)
          );
          setDeuda(deu);
          setHistorico(his);
        }
        setActivate(false);
        setMostrar5(true);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        //setActivate(false);
      });
  };

  const cerrarModalActualizar = () => {
    setAgente();
    setClaseMinaxAgen();
    setPersona();
    setMostrar5(false);
    consultar_minas();
  };

  return (
    <div className="col-sm-12 d-flex justify-content-center row">
      <div
        className="py-5"
        style={{ backgroundColor: "#", height: "100%", width: "100%" }}
      >
        <div className="row col-md-12 py-5 mx-auto">
          <div className="col-md-12 p-2">
            <div className="row col-md-12 d-flex justify-content-between">
              <input
                type="text"
                className=" col-2 form-control form-control-sm rounded-pill"
                onChange={handleSearch}
                placeholder="Buscar"
              />
            </div>
          </div>
          <div className="col-md-12" style={{ margin: "auto" }}>
            <TblContainer>
              <TblHead />

              <TableBody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <TableRow key={index} style={{ padding: "0" }}>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                      >
                        {item.idagente}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "start" }}
                      >
                        {item.nombre}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                      >
                        {item.rif}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                      >
                        {item.nrolicenciamina}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center", alignItems: "center" }}
                      >
                        {item.statusmina === "51" ? (
                          <span className="text-success2 mayuscula fw-bold">
                            Activo
                          </span>
                        ) : (
                          <span className="text-danger2 mayuscula fw-bold">
                            Inactivo
                          </span>
                        )}
                      </TableCell>
                      <TableCell
                        className="align-baseline"
                        style={{ textAlign: "center" }}
                      >
                        <button
                          disabled={item.statusmina === "51" ? false : true}
                          onClick={realizarDeclaracion(item)}
                          className="btn btn-sm btn-info rounded-pill"
                        >
                          <i
                            className="fas fa-edit"
                            style={{ fontSize: "12px" }}
                          >
                            Declarar
                          </i>{" "}
                        </button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </TblContainer>
            <TblPagination />
          </div>

          <ModalDeclararMinas
            show={mostrar5}
            onHideCancela={cerrarModalActualizar}
            agente={agente}
            representante={persona}
            tabdeuda={deuda}
            tabpago={historico}
            tabclaseminaxagen={claseMinaxAgen}
            deshabilitado={deshabilitado ? deshabilitado : undefined}
            config={configMinas}
            idusuario={idusuario}
            operacion={operacion}
            totdeuda={totDeuda}
          />
        </div>
        <Dimmer active={activate} />
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
      </div>
    </div>
  );
};
export default DeclaracionMina;



// WEBPACK FOOTER //
// ./src/pages/declaracionmina.js